import React, { useEffect, useState } from 'react';
import Button from '../../../../../component/ui/Button';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import UseRoles from './hooks/useRoles';
import PageLoader from '../../../../../component/PageLoader';
import Table from '../../../../../component/table/Table';
import trashIcon from '../../../../../assets/image/delete.svg';
import CreateRole from './createRole';
import { toast } from 'react-toastify';
import {
	createSettingsRole,
	getRoleById,
	UpdateSettingsRole,
} from '../../../../../services/settings/users';

export default function SettingsRoles({ activeTab }) {
	const {
		getRolesList,
		rolesList,
		loader,
		sortDirection,
		sortDataList,
		handleCloneRole,
		handleDeleteRole,
	} = UseRoles();
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const [createRole, setCreateRole] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateRoleLoading, setCreateRoleLoading] = useState(false);
	const [selectedRoleId, setSelectedRoleId] = useState(false);
	const [error, setError] = useState([]);
	const [rolePermissionList, setRolePermissionList] = useState([]);
	const [form, setForm] = useState({
		name: '',
		description: '',
		permissions: [],
	});
	const [roleForm, setRoleForm] = useState({});

	const getShowUndoChanged = () => {
		console.log('check');
		const hasChanged = JSON.stringify(roleForm) !== JSON.stringify(form);
		console.log(hasChanged);
		setIsEdit(hasChanged);
	};

	const checkValidation = () => {
		var err = { ...error };
		if (!form.name || form.name === '' || form.name === null || form.name === undefined) {
			err.name = 'Please enter name in the field';
		} else {
			delete err.name;
		}
		if (Object.keys(err).length > 0) {
			setError(err);
			return true;
		} else {
			return false;
		}
	};

	const handleRoles = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error('Creating role failed! Please fill required fields.');
		} else {
			setCreateRoleLoading(true);
			var res;
			if (selectedRoleId) {
				res = await UpdateSettingsRole(form, selectedRoleId);
			} else {
				res = await createSettingsRole(form);
			}
			if (res.success) {
				toast.success(res.message);
				setCreateRole(false);
				setIsEdit(false);
				setSelectedRoleId('');
				getRolesList();
			} else {
				toast.error(res.message);
			}
			try {
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setCreateRoleLoading(false);
			}
		}
	};

	const resetForm = () => {
		const data = {
			name: '',
			description: '',
			permissions: [],
		};
		setForm(data);
	};

	const getAllPermissionKeys = (subModules = []) => {
		return subModules.flatMap((sub) => sub.permissions.map((perm) => perm.key));
	};

	// usage
	// const permissionKeys = getAllPermissionKeys(data.sub_modules);

	const getRolePermissinById = async () => {
		try {
			const { role } = await getRoleById(selectedRoleId);
			var data = {
				name: role.name,
				description: role.description,
				permissions: getAllPermissionKeys(role?.permissions?.sub_modules),
			};
			setForm(data);
			setRoleForm(data);
		} catch (error) {
			toast.error(error.message || 'Somthing went wrong!');
		}
	};

	console.log(selectedRoleId);

	useEffect(() => {
		if (form) {
			getShowUndoChanged();
		}
	}, [form]);

	useEffect(() => {
		if (selectedRoleId) {
			getRolePermissinById();
		}
	}, [selectedRoleId]);

	const roleTableColumn = [
		{
			field: 'ROLE NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 300,
			flex: 1,
			autoHeight: true,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'name', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								ROLE NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				const name = params.data['role_name'];
				return (
					<div
						className="d-flex gap-3 align-items-center"
						style={{ height: '85px' }}
					>
						<div
							className="fs-5 fw-semibold p-1 cursor-pointer text-dark"
							onClick={(e) => {
								e.stopPropagation();
							}}
						>
							{name}
						</div>
					</div>
				);
			},
		},
		{
			field: 'DESCRIPTION',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'description', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								DESCRIPTION
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.description]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				return (
					<div
						className="d-flex align-items-center"
						style={{ height: '85px' }}
					>
						<div className="fs-5 fw-light text-dark">{params.data.description}</div>
					</div>
				);
			},
		},
		{
			field: 'ACTION',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 250,
			flex: 1,
			cellClass: 'left-align',
			cellRenderer: (params) => {
				const data = JSON.parse(params.data['action']);
				console.log(data);
				return (
					<div
						className="d-flex gap-3 align-items-center justify-content-center"
						style={{ height: '85px' }}
					>
						<div
							className="d-flex justify-content-center fs-6 fw-light text-center rounded-4 px-4 bg-primary cursor-pointer text-white"
							onClick={(e) => {
								e.stopPropagation();
								setCreateRole(true);
								setSelectedRoleId(data.id);
							}}
						>
							Edit
						</div>
						<div
							className="fs-6 fw-light rounded-4 px-4 cursor-pointer bg-primary text-white"
							onClick={(e) => {
								e.stopPropagation();
								handleCloneRole(data.id);
							}}
						>
							clone
						</div>
						<img
							src={trashIcon}
							alt="search-icon"
							width="25px"
							height="25px"
							className="rounded-circle m-2 cursor-pointer"
							onClick={(e) => {
								e.stopPropagation();
								handleDeleteRole(data.id);
							}}
						/>
					</div>
				);
			},
		},
	];

	return (
		<div>
			<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 100 }}>
				<div className="d-flex py-3 px-2 justify-content-between align-items-center">
					<div className="fs-4 fw-semibold">{createRole ? 'New Role' : activeTab}</div>
					<div className="d-flex gap-3">
						{!createRole ? (
							<Button
								type="button"
								className="mt-0 btn-primary fs-5 fw-light add-pro py-1"
								button="Add Role"
								add
								onClick={() => {
									setCreateRole(true);
									resetForm();
								}}
							/>
						) : (
							<>
								<Button
									type="button"
									className="btn-primary mt-0 fs-5 fw-light add-pro py-1 px-4"
									button="Save"
									disabled={isCreateRoleLoading}
									onClick={() => handleRoles()}
									loader={isCreateRoleLoading}
								/>

								{selectedRoleId && isEdit && (
									<Button
										type="button"
										className="btn-primary mt-0 fs-5 fw-light add-pro py-1 px-4"
										button="Undo Changed"
										onClick={() => {
											setIsEdit(false);
											getRolePermissinById();
										}}
									/>
								)}
								<Button
									type="button"
									className="mt-0 btn-danger add-pro"
									button=""
									close
									onClick={() => {
										setCreateRole(false);
										setIsEdit(false);
										setSelectedRoleId('');
									}}
								/>
							</>
						)}
					</div>
				</div>
			</div>
			{loader ? (
				<PageLoader />
			) : createRole ? (
				<CreateRole
					form={form}
					setForm={setForm}
					error={error}
					setError={setError}
					setRolePermissionList={setRolePermissionList}
					rolePermissionList={rolePermissionList}
				/>
			) : (
				<div className="productTable-body">
					<Table
						row={rolesList}
						coloum={roleTableColumn}
						className="productTable"
						style={{ height: 'calc(100vh - 112px)', backgroundColor: '#fff' }}
					/>
				</div>
			)}
		</div>
	);
}
